import type { ThemeColors } from '../../themes/ThemeTypes';

const colors: ThemeColors = {
  primary: '#ff0085',
  secondary: '#2648b2',
  tertiary: '#473eac',
  dark: '#0c1f28',
  light: '#afb6b9',
  extraLight: '#f0f0f0',
  white: '#ffffff',
  black: '#000000',
  grey: '#d3d3d3',
  off: '#858f93',
  offWhite: '#f5f5f5',
  primaryHover: '#d1006d',
  error: '#ff5a35',
  success: '#3Cba92',
  successDark: '#0ba360',
  external: '#05A0D1',
  cheap: '#d8f1e9',
  day: '#e1d6ea',
  peak: '#ffeea0',
  pale: '#2648b21a',
  solar: '#f8af1f',
  solarLight: '#f7d22d',
  footer: '#0c1f28',
  footerText: '#fff',
  imported: '#ff0085',
  exported: '#2648b2',
  headerText: '#fff',
  altText: '#fff',
  progressBar: 'linear-gradient(260deg, #6433a5, #2747b1 100%)',
  themedFormHeaders: '#000000',

  icons: {
    solarIconBackground: 'linear-gradient(80deg, #f8af1f, #f7d22d 100%)',
    batteryIconBackground: 'linear-gradient(260deg, #6433a5, #2747b1 100%)',
    gridIconBackground: '#fff',
    gridIconBorder: `2px solid ${'#0c1f28'}`,
    consumptionIconBackground: 'linear-gradient(260deg, #ff594f, #e5098b 100%)',
    inverterIconBackground: 'linear-gradient(80deg, #e5098b, #ff594f 100%)',
  },

  batteryActivity: {
    // Matches Figma “Today - Your Optimisation - new chart” legend colours
    gridCharge: '#00AEEF', // Charge battery from grid
    solarCharge: '#F15A29', // Charge from solar
    consumption: '#03A360', // Consume from battery
    export: '#344EA2', // Export to grid
    idle: '#939598', // Battery idle
  },

  gradients: {
    primary: 'linear-gradient(260deg, #822a9f, #3c41ae 100%)',
    secondary: 'linear-gradient(260deg, #bc1793, #772da1 100%)',
    tertiary: 'linear-gradient(to right, #2648b2, #473eac)',
    success: 'linear-gradient(80deg, #0ba360, #3cba92 100%)',
    danger: 'linear-gradient(260deg, #ff6a44, #ff2b69 100%)',
    warning: 'linear-gradient(260deg, #ff594f, #e5098b 100%)',
    info: 'linear-gradient(260deg, #6433a5, #2747b1 100%)',
    app: 'linear-gradient(80deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(245,245,245,1) 50%, rgba(245,245,245,1) 100%)',
    electricity: 'linear-gradient(80deg, #e5098b, #ff594f 100%)',
    heating: 'linear-gradient(80deg, #0259ab, #19d5ff 100%)',
    car: 'linear-gradient(80deg, #629c10, #74b816 100%)',
    solar: 'linear-gradient(80deg, #f8af1f, #f7d22d 100%)',
    solarReverse: 'linear-gradient(-80deg, #f8af1f, #f7d22d 100%)',
    header: 'linear-gradient(0deg, #2648B2, #473EAC 100%)',
    imported: 'linear-gradient(80deg, #e5098b, #ff594f 100%)',
    exported: 'linear-gradient(260deg, #bc1793, #772da1 100%)',
    alternative: 'linear-gradient(260deg, #473EAC, #2648B2 100%)',
  },

  verticalgradients: {
    primary: 'linear-gradient(180deg, #822a9f, #3c41ae 100%)',
    secondary: 'linear-gradient(180deg, #bc1793, #772da1 100%)',
    tertiary: 'linear-gradient(180deg, #6433a5, #2747b1 100%)',
    success: 'linear-gradient(0deg, #0ba360, #3cba92 100%)',
    danger: 'linear-gradient(180deg, #ff6a44, #ff2b69 100%)',
    warning: 'linear-gradient(180deg, #ff594f, #e5098b 100%);',
    info: 'linear-gradient(180deg, #6433a5, #2747b1 100%)',
    app: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(245,245,245,1) 50%, rgba(245,245,245,1) 100%)',
    electricity: 'linear-gradient(180deg, #e5098b, #ff594f 100%)',
    heating: 'linear-gradient(180deg, #0259ab, #19d5ff 100%)',
    car: 'linear-gradient(180deg, #629c10, #74b816 100%)',
    solar: 'linear-gradient(180deg, #f8af1f, #f7d22d 100%)',
    header: 'linear-gradient(0deg, #2648B2, #473EAC 100%)',
    solarReverse: 'linear-gradient(-180deg, #f8af1f, #f7d22d 100%)',
    imported: 'linear-gradient(-180deg, #e5098b, #ff594f 100%)',
    exported: 'linear-gradient(-180deg, #bc1793, #772da1 100%)',
    alternative: 'linear-gradient(180deg, #473EAC, #2648B2 100%)',
  },
};

export default colors;
